import {Outlet} from "react-router-dom";
import Box from '@mui/material/Box';
import Navigation from './navbar/Navigation';
import { LabContext } from "../context/lab";
import { useContext } from "react";
import GeneralInput from "./GeneralInput";

export default function PageLayout() {
  const {lab } = useContext(LabContext);
  return (<>
    <Navigation />
   
    <Box 
      component="main" 
      sx={{
        p: 3, mt: 2,
        mr: {xs: 0, md: 20},
        ml: {xs: 0, md: 20},
      }} 
    >
      <GeneralInput />
    </Box>
    <Box 
      component="main" 
      sx={{
        p: 3,
        mr: {xs: 0, md: 20},
        ml: {xs: 0, md: 20},
      }} 
    >
      {lab && <Outlet />}
    </Box>
  </>);
}